(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hercules-product"]) return;
  try {
    
(()=>{const root=document.getElementById('hercules-product-page');if(!root)return;const resetPanels=()=>root.querySelectorAll('[data-hp-reset-collapsed]').forEach(panel=>panel.open=false);resetPanels();window.addEventListener('pageshow',resetPanels);const variant=root.querySelector('#hp-variant');if(variant)variant.addEventListener('change',()=>{const url=new URL(window.location.href);url.searchParams.set('variant',variant.value);window.location.assign(url.href)});const frame=root.querySelector('.hp-main-image'),hero=root.querySelector('#hp-hero-image');const fitFrame=()=>{if(frame&&hero&&hero.naturalWidth&&hero.naturalHeight)frame.style.setProperty('--hp-image-ratio',hero.naturalWidth/hero.naturalHeight)};if(hero){hero.addEventListener('load',fitFrame);if(hero.complete)fitFrame()}root.querySelectorAll('[data-photo-url]').forEach(button=>button.addEventListener('click',()=>{if(!hero)return;hero.removeAttribute('srcset');hero.src=button.dataset.photoUrl;hero.alt=button.dataset.photoAlt;root.querySelectorAll('[data-photo-url]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hercules-related-items"]) return;
  try {
    
document.querySelectorAll('[data-hp-related-carousel]').forEach((section) => {
  const track = section.querySelector('[data-hp-related-track]');
  const previous = section.querySelector('[data-hp-related-prev]');
  const next = section.querySelector('[data-hp-related-next]');
  if (!track || !previous || !next) return;
  const updateButtons = () => {
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
  track.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);
  updateButtons();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
